export function StatusBadge({ value }: { value: unknown }) {
  const status = String(value ?? "unknown");
  const tone = statusTone(status);
  return <span className={`status-badge status-${tone}`}>{status.replaceAll("_", " ")}</span>;
}

function statusTone(status: string): string {
  if (["ready", "completed", "succeeded", "active", "healthy"].includes(status)) return "success";
  if (["failed", "unhealthy", "error"].includes(status)) return "danger";
  if (["queued", "running", "renting", "bootstrapping", "installing", "releasing", "in_progress", "pending"].includes(status)) return "warning";
  if (status === "released" || status === "deleted") return "muted";
  return "info";
}
